import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Field } from "./Login";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("Choose a new password")} sub={t("Pick something at least 8 characters long.")}>
      {done ? (
        <div className="rounded-xl border border-line bg-surface p-5 text-sm" data-testid="reset-done">
          <p className="font-bold text-good">{t("Password updated")}</p>
          <p className="mt-1 text-muted">{t("You can now log in with your new password.")}</p>
          <Link to="/login" className="mt-4 inline-block font-bold text-accent" data-testid="reset-login-link">{t("Go to login")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {!token && <p className="rounded-lg bg-warn/10 px-3 py-2 text-sm text-warn">{t("This link is missing its token. Use the link from your email.")}</p>}
          <Field id="password" label={t("New password")} type="password" value={password} onChange={(e) => setPassword(e.target.value)} testid="reset-password" autoComplete="new-password" placeholder={t("At least 8 characters")} />
          {error && <p className="rounded-lg bg-bad/10 px-3 py-2 text-sm text-bad" data-testid="reset-error">{error}</p>}
          <button type="submit" disabled={busy || !token} data-testid="reset-submit"
            className="w-full rounded-xl bg-accent px-4 py-3 text-sm font-bold text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60">
            {busy ? t("Updating…") : t("Update password")}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
